import React from 'react'
import { Box, Typography } from '@mui/material'

import type { IBlockPayloadImage } from '../../../types'

export const ImageRenderer: React.FC<{ payload: IBlockPayloadImage }> = ({ payload }) => {
  if (!payload.url) return null
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Box
        component="img"
        src={payload.url}
        alt={payload.alt ?? ''}
        sx={{ maxWidth: '100%', height: 'auto', borderRadius: 1 }}
      />
      {payload.caption && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
          {payload.caption}
        </Typography>
      )}
    </Box>
  )
}
